import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { Link, useParams } from 'react-router-dom'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import AreaView from '../../components/AreaView'
import { useProject } from '../../context/ProjectContext'


export default function AreaViewPage({ setBlockScreen }: any) {
  const { isProjectUndefined } = useProject()
  const params = useParams<{ area_code?: string }>()
  const area_code = params.area_code ?? ''

  return (<>
    <TopSideBar currentSection='areas' disableProjectSelector />
    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          <Link className='breadcrumbs-nav__link' to="/areas/listing">
            Áreas
          </Link>,
          'Detalle']}
        />
      </Box>

      {!isProjectUndefined() && (
        <AreaView
          area_code={area_code}
          setBlockScreen={setBlockScreen}
        />)}

    </PageContainer>
  </>)
}
